import React, { Component } from "react";
import { connect } from "react-redux";
import SignVendorAgreement from "containers/request/SignVendorAgreement";
import RequestResultPage from "components/request/RequestResultPage";
import Stepper from "components/Stepper";
import steps from "components/Stepper/initialSteps";
import PageHeader from "components/request/RequestPageHeader";
import InfoBar from "containers/request/Initial/SubmitInfoBar";
import InitialTabs from "containers/request/Initial/InitialTabs";
import { clearRequest, createInitialRequest } from "actions/request";
import { initWizard, clearWizard } from "actions/wizard";

class InitialSubmitPage extends Component {
  // init redux storage with default values for a request and a wizard
  componentDidMount() {
    this.props.createInitialRequest(this.props.user.company);
    this.props.initWizard();
  }

  componentWillUnmount() {
    this.props.clearRequest();
    this.props.clearWizard();
  }

  render() {
    const { request, wizard, history, user } = this.props;

    if (!user.cbrsvendoragreementflag) return <SignVendorAgreement />;

    if (request === null || wizard === null) {
      return "Loading...";
    }

    // const { step } = wizard;

    if (request.newId) {
      return (
        <RequestResultPage
          isInitial={true}
          isSubmit={wizard.isSubmitted}
          isSave={wizard.isSaved}
          history={history}
        />
      );
    }

    return (
      <div>
        <PageHeader />
        {/* <Stepper show={step < lastWizardStep} steps={steps} /> */}
        <Stepper show={true} steps={steps} />
        <InfoBar />
        <InitialTabs history={history} />
      </div>
    );
  }
}

function mapStateToProps({ request, user, wizard }) {
  return { request, user, wizard };
}

export default connect(mapStateToProps, {
  createInitialRequest,
  initWizard,
  clearRequest,
  clearWizard
})(InitialSubmitPage);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/InitialSubmitPage.js